import React from 'react'

import { css } from 'design'
import { cn } from 'util/cn'

export type TimelineActionProps = {
  header: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

export const TimelineAction = React.forwardRef<
  HTMLDivElement,
  TimelineActionProps
>(({ header, children, ...props }, ref) => {
  return (
    <section
      {...props}
      className={cn(timelineActionContainerStyles(), props.className)}
      ref={ref}
    >
      <header className={headerStyles()}>{header}</header>
      {children && (
        <section className={actionContainerStyles()}>{children}</section>
      )}
    </section>
  )
})

TimelineAction.displayName = 'TimelineAction'

export const timelineActionContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  backgroundColor: '$grey50',
  border: '1px solid $grey100',
  borderRadius: '$3',
  width: '100%',
  maxWidth: 350,

  '@md': {
    width: 350,
  },
})

const headerStyles = css({
  fontSize: '$3',
  color: '$foreground',
  padding: '$4',
  margin: 0,
})

const actionContainerStyles = css({
  padding: '$4',
  borderTop: '1px solid $grey100',
  width: '100%',
})
